<template>
  <div>
    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :options="[
        { type: 'date', label: '점검일' },
        { type: 'text', label: '점검장소' },
        { type: 'disaster', label: '재해형태' },
        { type: 'alert', label: '알림 대상자 선택' },
      ]" :board="this.board" :is-print="isPrint"/>

    <!--    장비정보-->
    <table-equipment
      class="mt-5"
      :list="form.equipmentList"
      @updateList="updateList"
      :isPrint="isPrint"
      :isReadonly="board.readonly"
    ></table-equipment>


    <!--    작업구분-->
    <vs-row class="mt-6">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5>
          <i class="dot"></i> 작업구분
        </h5>
      </vs-col>
    </vs-row>


    <div class="grid grid-cols-6 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-2 flex items-center">
        <!--        체크 1-->
        <div v-if="isPrint" class="flex items-center">
          <div
            v-if="form.check_1"
            style="background: #200c63"
            class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2"
          >
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          <div
            v-else
            style="border: 2px solid rgb(180, 180, 180)"
            class="w-5 h-5 rounded-sm mr-2"
          ></div>
          <span class="flex-1">
            {{ inspectionTitle_1 }}
          </span>
        </div>
        <div v-else>
          <span class="flex">
            <vs-checkbox
              :disabled="board.readonly"
              v-model="form.check_1"
            ></vs-checkbox>
            {{ inspectionTitle_1 }}
          </span>
        </div>
      </div>
      <div class="col-span-2 flex items-center">
        <!--        체크 2-->
        <div v-if="isPrint" class="flex items-center">
          <div
            v-if="form.check_2"
            style="background: #200c63"
            class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2"
          >
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          <div
            v-else
            style="border: 2px solid rgb(180, 180, 180)"
            class="w-5 h-5 rounded-sm mr-2"
          ></div>
          <span class="flex-1">
            {{ inspectionTitle_2 }}
          </span>
        </div>
        <div v-else>
          <span class="flex">
            <vs-checkbox
              :disabled="board.readonly"
              v-model="form.check_2"
            ></vs-checkbox>
            {{ inspectionTitle_2 }}
          </span>
        </div>
      </div>
      <div class="col-span-2 flex items-center">
        <!--        체크 3-->
        <div v-if="isPrint" class="flex items-center">
          <div
            v-if="form.check_3"
            style="background: #200c63"
            class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2"
          >
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          <div
            v-else
            style="border: 2px solid rgb(180, 180, 180)"
            class="w-5 h-5 rounded-sm mr-2"
          ></div>
          <span class="flex-1">
            {{ inspectionTitle_3 }}
          </span>
        </div>
        <div v-else>
          <span class="flex">
            <vs-checkbox
              :disabled="board.readonly"
              v-model="form.check_3"
            ></vs-checkbox>
            {{ inspectionTitle_3 }}
          </span>
        </div>
      </div>
    </div>


    <!--    폭염 작업-->
    <table-inspect
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :title="inspectionTitle_1"
      :list="form.inspectList_1"
      @update-list-check="updateListCheck_1"
      v-if="form.check_1"
    />
    <!--    풍수해 작업-->
    <table-inspect
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :title="inspectionTitle_2"
      :list="form.inspectList_2"
      @update-list-check="updateListCheck_2"
      v-if="form.check_2"
    />
    <!--    한랭 작업-->
    <table-inspect
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :title="inspectionTitle_3"
      :list="form.inspectList_3"
      @update-list-check="updateListCheck_3"
      v-if="form.check_3"
    />


    <!--    사진대지-->
    <PhotoUploadGridModule
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검"
    />

    <!--    파일첨부-->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>

  </div>
</template>

<script>
import PopupPlanProject from '@/views/project/popup/PopupPlanProject'
import DateSelector from '@/components/selector/DateSelector'
import PopupProjectSetting from '@/views/project/PopupProjectSetting'
import MemberSelector from '@/components/selector/MemberSelector'
import CompanySelector from '@/components/selector/CompanySelector'
import FileUploader from '@/components/FileUploader'
import FileUploadModule from '@/views/modules/FileUploadModule'
import TableInspect from '@/components/TableInspect'
import TableEquipment from '@/components/TableEquipment'
import DisasterClassSelector from '@/components/selector/DisasterClassSelector'
import FieldSelectModule from '@/views/modules/FieldSelectModule'
import PhotoUploadGridModule from '@/views/modules/PhotoUploadGridModule'

export default {
  components: {
    FileUploadModule,
    TableInspect,
    TableEquipment,
    DisasterClassSelector,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    FieldSelectModule,
    PhotoUploadGridModule
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler (value) {
        const keys = Object.keys(this.form)
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key]
          }
        }

        if (!this.form || !this.form.inspectList_1 || this.form.inspectList_1.length === 0) {
          this.form.inspectList_1 = this.inspectTable_1
        }
        if (!this.form || !this.form.inspectList_2 || this.form.inspectList_2.length === 0) {
          this.form.inspectList_2 = this.inspectTable_2
        }
        if (!this.form || !this.form.inspectList_3 || this.form.inspectList_3.length === 0) {
          this.form.inspectList_3 = this.inspectTable_3
        }
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler (value) {
        this.form.inspectionTitle
          = `${value.check_1 ? this.inspectionTitle_1 : ''}
            ${value.check_2 ? this.inspectionTitle_2 : ''}
            ${value.check_3 ? this.inspectionTitle_3 : ''}`

        this.$emit('input', value)
      }
    }
  },
  data () {
    return {
      inspectionTitle_1: '폭염 작업',
      inspectionTitle_2: '풍수해 작업',
      inspectionTitle_3: '한랭 작업',

      form: {
        stdInfo: { },
        photoList: [],

        check_1: false,
        check_2: false,
        check_3: false,
        fileList: [],
        equipmentList: [],
        inspectList_1: [],
        inspectList_2: [],
        inspectList_3: [],
      },
    }
  },
  computed: {
    inspectTable_1 () {
      return [
        {
          id: 1,
          label: '우리 사업장에서 열원이 발생하거나 열원을 취급하는지에 대해 분류･파악하고 있는가?',
          is_checked: ''
        },
        {
          id: 2,
          label: '우리 사업장에서 고열의 유해성･위험성 및 관리방안을 근로자에게 주지 시키고 있는가?',
          is_checked: ''
        },
        {
          id: 3,
          label: '작업환경측정 등을 통해 근로자에게 노출되는 고열 노출수준을 관리하고 있는가?',
          is_checked: ''
        },
        {
          id: 4,
          label: '측정결과에 따라 적정한 열원 등의 적정한 관리방안을 마련하고 있는가?',
          is_checked: ''
        },
        {
          id: 5,
          label: '근로자를 배치하기 전 근로자의 건강상태와 특성 등을 고려하여 배치 하고 있는가?',
          is_checked: ''
        },
        {
          id: 6,
          label: '열원의 격리와 작업장 내 온･습도 조절을 위한 냉방장치 등이 설치되어 있는가?',
          is_checked: ''
        },
        {
          id: 7,
          label: '작업의 강도에 따른 휴식시간을 적절히 부여하고, 쾌적한 휴게공간을 제공하고 있는가?',
          is_checked: ''
        },
        {
          id: 8,
          label: '비상시 온도를 낮추거나 열을 차단할 수 있는 냉각시스템이 구축되어 있는가?',
          is_checked: ''
        },
        {
          id: 9,
          label: '근로자들이 휴식시간에 이용할 수 있는 휴게시설을 갖추고 있는가?',
          is_checked: ''
        },
        {
          id: 10,
          label: '다량의 고열물체를 취급하는 장소 등에 관계 근로자 외 출입을 금지하고 그 내용을 게시하고 있는가?',
          is_checked: ''
        },
      ]
    },
    inspectTable_2 () {
      return [
        {
          id: 1,
          label: '풍수해 대비 비상매뉴얼은 작성하는가?',
          is_checked: ''
        },
        {
          id: 2,
          label: '매뉴얼에 따른 업무분장이 적합한가?',
          is_checked: ''
        },
        {
          id: 3,
          label: '사전 비상대비 훈련을 실시하는가?',
          is_checked: ''
        },
        {
          id: 4,
          label: '예상 강우량에 따라 우수 유입량은 계산하는가?',
          is_checked: ''
        },
        {
          id: 5,
          label: '현장 구간 내 시설물에 대한 우수 등의 유입에 대한 안전성평가가 이루어지는가?',
          is_checked: ''
        },
        {
          id: 6,
          label: '배수계획도는 작성되었는가?',
          is_checked: ''
        },
        {
          id: 7,
          label: '수방자재는 확보되었는가?\n' +
            '※ 양수기(고장 시 대비 여유분 포함), 마대, 가마니, 삽, 리어카, 우비, 장화, 렌턴 등',
          is_checked: ''
        },
        {
          id: 8,
          label: '비상대기반을 편성하였는가?',
          is_checked: ''
        },
        {
          id: 9,
          label: '작업중지 명령 체계가 확립되었는가?',
          is_checked: ''
        },
        {
          id: 10,
          label: '발주처 및 원하청 간 비상 연락망은 구축되었으며 실제 운영하는가?',
          is_checked: ''
        },
        {
          id: 11,
          label: '비상사태 발생 시 이에 대한 대책 수립을 하는가?\n' +
            '※ 집중호우 시 자재 및 장비 대피 계획 등',
          is_checked: ''
        },
      ]
    },
    inspectTable_3 () {
      return [
        {
          id: 1,
          label: '우리 사업장에서 한랭작업이 발생하거나 취급하는지에 대해 분류･파악하고 있는가?',
          is_checked: ''
        },
        {
          id: 2,
          label: '우리 사업장에서 한랭의 유해성･위험성 및 관리방안을 근로자에게 주지시키고 있는가?',
          is_checked: ''
        },
        {
          id: 3,
          label: '작업환경측정 등을 통해 근로자에게 노출되는 한랭 노출수준을 관리하고 있는가?',
          is_checked: ''
        },
        {
          id: 4,
          label: '측정결과에 따라 적정한 열원 등의 적정한 관리방안을 마련하고 있는가?',
          is_checked: ''
        },
        {
          id: 5,
          label: '근로자를 배치하기 전 근로자의 건강상태와 특성 등을 고려하여 배치하고 있는가?',
          is_checked: ''
        },
        {
          id: 6,
          label: '저온환경의 격리와 작업장 내 온･습도 조절을 위한 난방장치 등이 설치되어 있는가?',
          is_checked: ''
        },
        {
          id: 7,
          label: '작업의 강도에 따른 휴식시간을 적절히 부여하고, 쾌적한 휴게공간을 제공하고 있는가?',
          is_checked: ''
        },
        {
          id: 8,
          label: '비상시 온도를 낮추거나 열을 차단할 수 있는 난방시스템이 구축되어 있는가?',
          is_checked: ''
        },
        {
          id: 9,
          label: '근로자들이 휴식시간에 이용할 수 있는 휴게시설을 갖추고 있는가?',
          is_checked: ''
        },
        {
          id: 10,
          label: '다량의 저온물체를 취급하는 장소 등에 관계근로자 외 출입을 금지하고 그 내용을 게시하고 있는가?',
          is_checked: ''
        },
      ]
    },
  },
  methods : {
    updateList (list) {
      this.form.equipmentList = list
    },
    updateListCheck_1 (indexRows, text) {
      this.form.inspectList_1[indexRows].is_checked = text
    },
    updateListCheck_2 (indexRows, text) {
      this.form.inspectList_2[indexRows].is_checked = text
    },
    updateListCheck_3 (indexRows, text) {
      this.form.inspectList_3[indexRows].is_checked = text
    },
  }
}
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}
.upload-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }
  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>
